import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
//
import { Header } from "../../../common";
import { history } from "../../../../store/configure/configureStore";
import { FaPen } from "react-icons/fa";
import { FaArrowLeftLong } from "react-icons/fa6";
import { VscPreview } from "react-icons/vsc";
//
import {
  CardView,
  ButtonView,
  ModalView,
  Input,
  Select,
  TagView,
  TextToInputView,
  ColorInput,
  Checkbox,
} from "../../../controls";
import Preview from "./components/Preview";
//
import "./ViewBannerStyles.scss";

const ViewBannerView = ({
  newFields,
  status,
  bannerScreen,
  editField,
  fileInput,
  device,
  checkedItems,
  imageBackgroundColor,
  //
  subscriptionList,
  //
  deviceDropDownOptions,
  //
  handleDeviceChange,
}) => {
  console.log("device", device);

  const titleStyles = {
    color: newFields?.title?.color,
    fontSize: `${newFields?.title?.fontSize}px`,
  };

  const subTitleStyles = {
    color: newFields?.subTitle?.color,
    fontSize: `${newFields?.subTitle?.fontSize}px`,
  };

  const primaryButtonStyles = {
    backgroundColor: newFields?.primaryBtnTitle?.color,
    fontSize: `${newFields?.primaryBtnTitle?.fontSize}px`,
    borderRadius: "50px",
    border: "none",
    width: "fit-content",
  };

  const secondaryButtonStyles = {
    backgroundColor: newFields?.secondaryBtnTitle?.color,
    fontSize: `${newFields?.secondaryBtnTitle?.fontSize}px`,
    borderRadius: "50px",
    border: "none",
    width: "fit-content",
  };

  const displayTitle =
    newFields?.title?.title && newFields?.title?.visibility?.label !== "hidden";

  const displaySubTitle =
    newFields?.subTitle?.subTitle &&
    newFields?.subTitle?.visibility?.label !== "hidden";

  const displayPrimaryBtn =
    newFields?.primaryBtnTitle?.primaryBtnTitle &&
    newFields?.primaryBtnTitle?.visibility?.label !== "hidden";

  const displaySecondaryBtn =
    newFields?.secondaryBtnTitle?.secondaryBtnTitle &&
    newFields?.secondaryBtnTitle?.visibility?.label !== "hidden";

  const renderBannerPreviewContent = () => {
    return (
      <div className="preview-content-wrapper">
        <div className="preview-screen-selection-block">
          <Select
            label={"Preview"}
            options={deviceDropDownOptions}
            value={deviceDropDownOptions.find(
              (item) => item.label === device?.name
            )}
            placeholder={"select device"}
            onChange={handleDeviceChange}
            styles={{
              menuList: (baseStyles, state) => ({
                ...baseStyles,
                height: "200px",
                overflow: "auto",
              }),
            }}
          />
        </div>
        <div className="preview-content">
          <Preview
            imgSrc={fileInput}
            defaultImgSrc={
              "https://via.placeholder.com/600x400?text=Upload+Image"
            }
            title={newFields?.title}
            subTitle={newFields?.subTitle}
            primaryButton={newFields?.primaryBtnTitle}
            secondaryButton={newFields?.secondaryBtnTitle}
            device={device}
            //
            imageBackgroundColor={imageBackgroundColor}
          />
        </div>
      </div>
    );
  };

  const renderCheckList = () => {
    //extract the name of already checked items
    const isChecked = checkedItems?.map((item) => item.name);
    // console.log("isChecked", isChecked);

    // Define the specific items to add
    const flagItems = [
      {
        _id: "sahaj-id",
        name: "Sahaj",
        isActive: true,
        isFlagItem: true,
      },
      {
        _id: "sky-id",
        name: "Sky",
        isActive: true,
        isFlagItem: true,
      },
    ];

    // Combine flag items with filtered subscription list
    const combinedList = [
      ...(subscriptionList?.filter((item) => item?.isActive) || []),
      ...flagItems,
    ];

    // Filter combinedList to include only items present in isChecked
    const filteredList = combinedList.filter((item) =>
      isChecked.includes(item.name)
    );

    return (
      <div className="list-wrapper">
        {filteredList.map((item) => (
          <span className="list" key={item._id}>
            <Checkbox
              checked={isChecked.includes(item?.name)}
              iconSize={10}
              text={item.name}
            />
          </span>
        ))}
      </div>
    );
  };
  return (
    <div className="view_banner--container">
      <div className="view_banner--header-wrapper">
        <div className="action">
          <FaArrowLeftLong
            size={25}
            onClick={() => {
              history.goBack();
            }}
          />
        </div>
        <div className="title-content">Banner</div>
      </div>
      <div className="view_banner--main-content-wrapper">
        <div className="left-side-content-block">
          <div className="banner-preview-block">
            {renderBannerPreviewContent()}
          </div>
          <div className="checklist-block">{renderCheckList()}</div>
        </div>
        <div className="right-side-content-block">
          <div className="text-block text-only">
            <span className="text-label">Banner Screen</span>
            <span className="partition">:</span>
            <span>{bannerScreen?.label}</span>
          </div>
          <div className="text-block text-only">
            <span className="text-label">Status</span>
            <span className="partition">:</span>
            <span>{status?.label}</span>
          </div>
          <div className="action-block">
            {/* <div className="action-wrapper">
              <ButtonView
                title="Cancel"
                styles={"secondary"}
                onClick={() => {
                  history.push("/media/banner-management");
                }}
              />
            </div>
            <div className="action-wrapper">
              <ButtonView
                title="Update"
                styles={"secondary"}
                onClick={onClickSubmit}
              />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewBannerView;
